
import moment from 'moment';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getPayments } from '@/api/coinManaging';
import { PageQuery } from '@/mixins/page_query';
import { ePayType } from '@/interface/eCommand';

@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class RechargeQuery extends Vue {
  private order_no = '';
  private nickname = '';
  private out_order_no = '';
  private uid = '';

  private tableData = [];
  private payTypes = ['未知', '微信', '兑换码'];
  epayType = ePayType;
  private payTp = 0;
  total: number = 0;
  page: number = 0;
  page_size: number = 30;
  loading: boolean = false;
  searchList() {
    if (!this.order_no && !this.nickname && !this.uid && !this.out_order_no) {
      this.$message('请输入查询条件');
      return;
    }
    this.page = 1;
    this.getList();
  }
  handleSizeChange(page_size: number) {
    this.page = 1;
    this.page_size = page_size;
    if (!this.order_no && !this.nickname && !this.uid && !this.out_order_no) {
      this.$message('请输入查询条件');
      return;
    }
    this.getList();
  }
  handleCurrentChange(page: number) {
    this.page = page;
    if (!this.order_no && !this.nickname && !this.uid && !this.out_order_no) {
      this.$message('请输入查询条件');
      return;
    }
    this.getList();
  }
  async getList() {
    this.loading = true;
    try {
      const query = {
        page: this.page,
        page_size: this.page_size,
        nickname: this.nickname,
        uid: this.uid,
        order_no: this.order_no,
        out_order_no: this.out_order_no,
      };
      const res = await getPayments(query);
      if (res && res.data.list) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
      this.loading = false;
    } catch (error) {
      // this.$log.debug(error);
      this.loading = false;
    }
  }

  mounted() {}
}
